import React from 'react'
import mockup from '../Assets/mockup-insta.webp'
import Counter from '../Components/Counter'
import BtnDefault from '../Components/BtnDefault'
import AutoShowComponent from '../Components/AutoShowComponent'


function Insta() {
  return (
    <section id="insta-section" className='medium-checkered-background-light padding-50 flex-center text-dark'>
      <div className='flex-center flex__gap-100 mobile-flex__column'>
        <AutoShowComponent 
        srcImg={mockup}
        altImg="Mockup Instagram"
        width="200" 
        height="491"
        />

        <div className='flex-center flex-column flex__gap-30 flex__align-start wd-400 mobile-flex__column mobile-wd-90p'>
            <div>
                <div className='followers-container extra-bold mobile-justify-center'>
                  <Counter num1="4" num2="2" num3="9"/>
                  <h2 className='title-main'>Mil</h2>
                </div>
                
                <h2 className='subtitle-main'>Seguidores no Instagram</h2>
            </div>
            <p className='paragraph-default'>Com uma comunidade crescente de fãs e seguidores, Raffa inspira e motiva pessoas através de seu conteúdo autêntico, ele compartilha não apenas sua rotina de exercícios e dicas de receitas, mas também momentos especiais de suas viagens e experiências pessoais.</p>
            <BtnDefault socialMedia="Instagram" link="https://www.instagram.com/raffaelfragoso/"/>
        </div>
      </div>
    </section>
  )
}

export default Insta
